import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import Img from "../media/servise.jpg"


export default function Servise() {
  return (
    <section className="pozostale">
      <>
          <Helmet>
              <title>Pro Moto - serwis motocykli</title>
              <meta
              name="description"
              content="PRO MOTO Oferujemy kompleksowy serwis motocykli, quadów i skuterów — od podstawowej obsługi po zaawansowane naprawy"
              />
              <link rel="canonical" href="https://promotoserwis.pl/serwis" />
          </Helmet>
      </>
      <div className="pozostale-container">
        <motion.div
          className="pozostale-image"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src={Img}
            alt="Motocykl"
          />
        </motion.div>

        <motion.div
          className="pozostale-content"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2>Serwis</h2>
            <p>
            Oferujemy kompleksowy serwis motocykli, quadów i skuterów — od podstawowej
            obsługi po zaawansowane naprawy. Zajmujemy się diagnostyką, przeglądami
            technicznymi, wymianą części oraz przygotowaniem motocykla do sezonu.
            Dbamy o każdy detal, aby Twój pojazd był bezpieczny i gotowy do jazdy.
            </p>
          <ul className="pozostale-list">
            <li>
              <Link to="/serwis-motocykli">Serwis motocykli</Link>
            </li>
            <li>
              <Link to="/serwis-quadow">Serwis quadów</Link>
            </li>
            <li>
              <Link to="/serwis-skuterow">Serwis skuterów</Link>
            </li>
            <li>
              <Link to="/przeglady-techniczne">Przeglądy techniczne</Link>
            </li>
            <li>
              <Link to="/cennik">Cennik</Link>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
